import { IMedicalService } from 'interfaces';
import { axiosPrivate } from 'services/axios';
import { BaseService } from './BaseService';

class MedicalServiceService extends BaseService<IMedicalService> {
  constructor() {
    super('medical-services');
  }
  canBulkDelete = true;

  generateLines = async (values: Record<string, unknown>) => {
    const res = await axiosPrivate.postForm(`${this.modulePrefix}/generate-lines/`, values);
    return res.data;
  };

  importLisFile = async (importFile: File) => {
    const res = await axiosPrivate.postForm(`${this.modulePrefix}/import-lis-file/`, {
      file: importFile
    });
    return res.data;
  };

  importAggregatedLinesFromFile = async (importFile: File, attachmentName = 'import_file') => {
    const res = await axiosPrivate.postForm(
      `${this.modulePrefix}/import-aggregated-lines-from-file/`,
      {
        [attachmentName]: importFile
      }
    );
    return res.data;
  };

  getImportTemplate = async () => {
    axiosPrivate
      .get(`${this.modulePrefix}/aggregated_import_template/`, {
        responseType: 'blob'
      })
      .then((res) => {
        const url = window.URL.createObjectURL(new Blob([res.data]));
        const contentDisposition = res.headers['content-disposition'];
        if (contentDisposition?.indexOf('attachment') !== -1) {
          const filenameMatches = contentDisposition.match(
            /(?:.*filename\*|filename)=(?:([^'"]*)''|("))([^;]+)\2(?:[;`\n]|$)/
          );
          const filename = filenameMatches.pop();
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', filename);
          document.body.appendChild(link);
          link.click();
        }
      });
  };
}

export const medicalServiceService = new MedicalServiceService();
